import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import ReactTable from 'react-table';
import Swal from 'sweetalert2';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { createFetch } from '../../../utils';
import lang from '../../../lang';
import '../../../styles/users.scss';
const { URL_PREFIX } = window;


class Profiles extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            profileList: [],
            loading: false,
            pageSize: 10,
            page: 1,
        };
        // this.deleteProfile = this.deleteProfile.bind(this);
    }

    componentWillMount() {
        this.getProfileList();
    }

    async getProfileList() {
        const { user } = this.props;
        this.setState({ loading: true });
        const { page, pageSize } = this.state;
        try {
            const list = await createFetch({
                path: `users/profile/list?page=${page}&limit=${pageSize}`,
                accessToken: user.accessToken,
                body: null,
                method: 'GET',
            });
            this.setState({ loading: false, profileList: list.records });
        } catch (error) {
            this.setState({ loading: false });
            Swal.fire({
                title: lang.titleError,
                text: error.message,
                type: 'error',
            });
        }
    }

    async deleteProfile(id) {
        const { user } = this.props;
        const { profileList, loading } = this.state;
        
        const res = await Swal.fire({
            title: `${lang.dialogue.areYouSure}?`,
            text: lang.dialogue.willNotRecover,
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: lang.common.yes,
            cancelButtonText: lang.common.no,
        });
        if (!res.value) return;
        if (loading) return;
        this.setState({ loading: true });
        try {
            const response = await createFetch({
                path: 'users/profile/delete',
                accessToken: user.accessToken,
                body: {
                    id,
                },
                method: 'POST',
            });
            if (response.status === 200) {
                const profileDetail = profileList.find(o => o.id === id);
                Swal.fire({
                    title: `Profile ${lang.common.delete}`,
                    text: `Profile ${profileDetail.name} ${lang.dialogue.successDeleted}`,
                    type: 'success',
                });
                this.getProfileList();
                return;
            }
            let { message } = response;
            if (response.status === 400) {
                const serverValidation = response.validation.find(o => o.param === 'id');
                message = serverValidation === null ? message : lang.serverMessage[serverValidation.msg];
            }
            throw new Error(message);
        } catch (error) {
            this.setState({ loading: false });
            Swal.fire({
                title: lang.titleError,
                text: error.message,
                type: 'error',
            });
        }
    }

    render() {
        const { loading, profileList } = this.state;
        return (
            <div className="" id="profileSettingPage">
                <div className="intro col-lg-6 col-sm-12" style={{ padding: 0, marginBottom: 10 }}>
                    <h2>{lang.profile.title}</h2>
                    <p>{lang.profile.description}</p>
                    <Link to={`${URL_PREFIX}/app/profile/new`} className="btn btn-alternate">
                        {lang.profile.newProfile}
                    </Link>
                </div>
                <div className="clearfix" />
                <div className="col-lg-12" style={{ padding: 0 }}>
                    <ReactTable
                        data={profileList}
                        defaultPageSize={10}
                        loading={loading}
                        columns={[{
                            Header: lang.common.action,
                            accessor: 'id',
                            Cell: col => (
                                <div className="action-table">
                                    <Link to={`${URL_PREFIX}/app/profile/${col.value}`}>
                                        {lang.common.edit}
                                    </Link>
                                    <Link
                                        to={`${URL_PREFIX}/app/profile/delete/${col.value}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.deleteProfile(col.value);
                                        }}
                                    >
                                        {lang.common.delete}
                                    </Link>
                                </div>
                            ),
                        }, {
                            Header: lang.profile.columnName.name,
                            accessor: 'name',
                        }, {
                            Header: lang.profile.columnName.totalUserAssigned,
                            accessor: 'totalUserAssigned',
                        }, {
                            Header: lang.profile.columnName.updatedAt,
                            accessor: 'updatedAt',
                            Cell: col => moment(col.value).format('DD-MMM-YYYY HH:mm a'),
                        }, {
                            Header: lang.profile.columnName.createdAt,
                            accessor: 'createdAt',
                            Cell: col => moment(col.value).format('DD-MMM-YYYY HH:mm a'),
                        }]}
                        manual
                        className="-striped -highlight"
                        onFetchData={(state) => {
                            this.setState({ pageSize: state.pageSize, page: state.page }, this.getProfileList);
                        }}
                    />
                </div>
            </div>
        );
    }
}

Profiles.propTypes = {
    user: propTypes.object.isRequired,
};


const mapDispatchToProps = dispatch => (
    bindActionCreators({
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
});


export default connect(mapStateToProps, mapDispatchToProps)(Profiles);